import StaticPage from "@/pages/StaticPage";
export default function Anniversary() { return <StaticPage slug="aniversario" />; }
